import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/industries/MediaEnterainmentIndustries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/DynamicPortfolio.tsx");
